exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h6 {\n  color: dimgray;\n  font-size: 0.8rem; }\n\n.border-light {\n  border-color: lightgray !important; }\n\n.fecha {\n  color: #a7a7a7;\n  font-size: 0.7rem; }\n\n.error {\n  color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/conciliacion/conciliacion-chart-item.component.scss
// module id = ../../../../../src/app/components/conciliacion/conciliacion-chart-item.component.scss
// module chunks = main